export const REDIRECT_DELAY = 4000;

export const SEND_SMS_TEMPLATE = {
  IDNOW_APP_LINK: 'idnow-app-link',
  QONTO_VERIFICATION_FOURTHLINE: 'qonto-verification-fourthline',
};
